export default {"src":"https://site.joinleland.com/_next/static/media/blur.2b29e4ad.gif","height":200,"width":388,"blurWidth":0,"blurHeight":0};